import React from "react";
import { Outlet, useNavigate, useParams, useLocation, matchPath } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const TABS = [
  { label: "Overview", path: "overview", icon: <DashboardOutlinedIcon fontSize="small" /> },
  { label: "Inbox", path: "inbox", icon: <InboxOutlinedIcon fontSize="small" /> },
  { label: "Rules", path: "rules", icon: <TuneOutlinedIcon fontSize="small" /> },
  { label: "Settings", path: "settings", icon: <SettingsOutlinedIcon fontSize="small" /> },
];

export default function MerchantShell() {
  const { tenantSlug } = useParams();
  const nav = useNavigate();
  const location = useLocation();
  const slug = tenantSlug || "";

  const activeTab = TABS.findIndex((t) =>
    matchPath(`/merchant/${slug}/${t.path}/*`, location.pathname)
  );

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "background.default" }}>
      <AppBar position="sticky" elevation={0}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 2,
                display: "grid",
                placeItems: "center",
                bgcolor: "primary.main",
                color: "white",
              }}
            >
              <SwapHorizIcon fontSize="small" />
            </Box>
            <Typography variant="subtitle1" fontWeight={700} noWrap>
              Salla Returns
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>

      <Box sx={{ px: { xs: 2, md: 3 }, pt: 3, pb: 1 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "flex-end" }}
          spacing={2}
        >
          <Box>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Typography variant="h5">Command Center</Typography>
              <Chip label="LIVE" size="small" color="success" variant="outlined" />
            </Stack>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              Monitoring returns for <strong>{slug || "Store"}</strong>
            </Typography>
          </Box>

          <Tabs
            value={activeTab >= 0 ? activeTab : 0}
            onChange={(_, idx) => nav(`/merchant/${slug}/${TABS[idx].path}`)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ "& .MuiTab-root": { minHeight: 44, px: 2 } }}
          >
            {TABS.map((t) => (
              <Tab key={t.path} label={t.label} icon={t.icon} iconPosition="start" />
            ))}
          </Tabs>
        </Stack>
      </Box>

      <Box component="main" sx={{ flex: 1, px: { xs: 2, md: 3 }, py: 2 }}>
        <Outlet />
      </Box>

      <Box
        component="footer"
        sx={{
          py: 2,
          px: 3,
          textAlign: "center",
          borderTop: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={600}>
          Built for Salla &middot; Powered by Zoho Catalyst AppSail
        </Typography>
      </Box>
    </Box>
  );
}
